import { CANARY_COOKIE_NAME } from '../apiHelpers';

export const updateAuthRequestData = (requestData, pathData) => {
  const { token, lang, company, [CANARY_COOKIE_NAME]: deliveryMethod } = pathData;
  const { headers = {}, ...rest } = requestData;

  const updateHeader = {
    Authorization: `Bearer ${token}`,
    'Accept-Language': lang,
  };

  const updateCompany = company
    ? {
        CompanyId: company,
      }
    : {};

  const updateDeliveryMethod = deliveryMethod
    ? {
      [CANARY_COOKIE_NAME]: deliveryMethod,
    }
    : {};

  return {
    ...rest,
    headers: {
      ...updateHeader,
      ...updateCompany,
      ...updateDeliveryMethod,
      ...headers,
    },
  };
};

export const updatePaymentAuthRequestData = (requestData, pathData) => {
  const { token, lang, company, [CANARY_COOKIE_NAME]: deliveryMethod, payment_provider, username, accountId } = pathData;
  const { headers = {}, ...rest } = requestData;

  const updateHeader = {
    Authorization: `Bearer ${token}`,
    'Accept-Language': lang,
  };

  const updateCompany = company
    ? {
        'Company-Id': company,
      }
    : {};

  const updateDeliveryMethod = deliveryMethod
    ? {
        [CANARY_COOKIE_NAME]: deliveryMethod,
      }
    : {};

  const updatePaymentProvider = payment_provider
    ? {
        'x-payment-provider': payment_provider,
      }
    : {};

  const updateUsername = username
    ? {
        username,
      }
    : {};

  const updateAccountId = accountId
    ? {
        'Account-Id': accountId,
      }
    : {};

  return {
    ...rest,
    headers: {
      ...updateHeader,
      ...updateCompany,
      ...updateDeliveryMethod,
      ...updatePaymentProvider,
      ...updateUsername,
      ...updateAccountId,
      ...headers,
    },
  };
};
